'use strict';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';
import React from 'react';
import PropTypes from 'prop-types';

export default class ImportForm extends React.Component {
  static propTypes = {
    token: PropTypes.string.isRequired,
    importUrl: PropTypes.string.isRequired,
    cancelUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      fileIsEmpty: true,
    };
  }

  file() {
    return this.refs.inputFile.files[0];
  }

  onFileChange(e) {
    if (this.file() === undefined) {
      this.setState({fileIsEmpty: true});
    } else {
      this.setState({fileIsEmpty: false});
    }
  }

  formData() {
    var data = new FormData();
    data.append('file', this.file());
    return data;
  }

  resetForm() {
    var form = this.refs.form;
    form.reset();
    this.setState({fileIsEmpty: true});
  }

  callApiToImport() {
    var ref = this;
    fetch(
      this.props.importUrl, {
        method: 'POST',
        body: this.formData(),
        headers: { 'X-CSRF-Token': this.props.token },
        credentials: 'same-origin',
      }
    ).then(
      function (res) {
        if (res.ok) {
          alert('Import started');
          ref.resetForm();
        } else {
          alert('Invalid file');
        }
      }
    );
  }

  onBtnClickHandler(e) {
    e.preventDefault();
    this.callApiToImport();
  }

  render() {
    return (
      <form encType="multipart/form-data" ref="form">
        <fieldset className="inputs">
          <legend><span>Details</span></legend>
          <ol>
            <li className="file input required">
              <label htmlFor="file" className="label">File</label>
              <input
                type="file"
                name="fileName"
                ref="inputFile"
                onChange={this.onFileChange.bind(this)} />
            </li>
          </ol>
        </fieldset>
        <fieldset className="actions">
          <ol>
            <li className="action input_action">
              <input
                type="button"
                value="Upload"
                ref="uploadButton"
                onClick={this.onBtnClickHandler.bind(this)}
                disabled={this.state.fileIsEmpty} />
            </li>
            <li className="cancel">
              <a href={this.props.cancelUrl}>Cancel</a>
            </li>
          </ol>
        </fieldset>
      </form>
    );
  }
}
